export const POSTING_UPDATED_METADATA = 'posting_updated_metadata';
export const COMPLETED_SAVE_METADATA = 'completed_save_metadata';
export const METADATA_UPDATE_FAILED = 'metadata_update_failed';
